import { cn } from '@/utils/classname';

export function Divider(props: { className?: string }) {
  return (
    <div
      className={cn(
        'bg-chariot-stroke h-[2px] w-full shrink-0 rounded-lg',
        props.className
      )}
    />
  );
}
